import styled from "@emotion/styled";

import { fontRoboto } from "shared/lib/styles";

import { EntityLink } from "scmp-app/components/entity-link";

export const StyledEntityLink = styled(EntityLink)`
  color: #000000;
  font-weight: 700;
  font-size: 20px;
  font-family: ${fontRoboto};
  line-height: normal;
`;
